
/* injects from baggage-loader */

'use strict';

// node_modules
import "angular";
import "@uirouter/angularjs";
import "angular-resource";
import "oclazyload";
import "angular-animate";
import "angular-cookies";
import "angular-touch";
import "angular-sanitize";
import "angular-messages";
import "angular-aria";
import "jquery";
import "angular-resource";
import "angular-scroll";
import "angular-loading-bar";
import "angular-avatar";
import "angular-timeago";
import "angular-stripe";
import "ng-file-upload";
import "angular-drag-and-drop-lists";

// Node module CSS
import "angular-loading-bar/build/loading-bar.css";

// Setup TextAngular
(() => {
  window.taTools = {};
  window.rangy = require('rangy/lib/rangy-core');
})();
// import 'textAngular/dist/textAngular.css';
require('rangy/lib/rangy-selectionsaverestore');
require('textangular/dist/textAngular-sanitize');
require('textAngular/dist/textAngularSetup');
require('textAngular/dist/textAngular');

// local scripts
//import "../assets/js/...";



// WEBPACK FOOTER //
// ./src/app/index.vendor.js